import { IncomingMessage } from 'http';

import { QueryFunction, QueryKey } from '@tanstack/react-query';

import fetchRelated from '../../../services/products/fetch-related';

const getRelatedProducts = (
  options: {
    locale: string;
    slug: string;
    shipping_location?: string;
    detailed_prices?: boolean;
  },
  req?: IncomingMessage
): [QueryKey, QueryFunction<ReturnType<typeof fetchRelated>>] => [
  [
    'user-dependent',
    'related-products',
    {
      locale: options.locale,
      slug: options.slug,
      detailed_prices: options.detailed_prices,
    },
  ],
  ({
    queryKey: [, , key],
  }: {
    queryKey: [
      string,
      string,
      {
        locale: string;
        slug: string;
        detailed_prices?: boolean;
      }
    ];
  }) => fetchRelated(options, req),
];

export default getRelatedProducts;
